import { useVisitorsStore } from '@/shared/store'
import type { VisitorType } from '@/shared/types/store.types'

export const useVisaPreapproval = () => {
  const visitorsStore = useVisitorsStore()

  const getPreapprovalVisitor = (visitor: VisitorType): Promise<VisitorType> =>
    visitorsStore
      .getPreapprovalVisa(visitor)
      .then((data) => ({ ...visitor, ...data }))
      .catch(() => ({
        ...visitor,
        visaValidityDate: undefined,
        policyDuration: visitorsStore.holder.policyDuration || visitorsStore.entryValue,
      }))

  const hasPreapprovalVisa = (visitor: VisitorType): boolean => !!visitor.visaValidityDate

  return { getPreapprovalVisitor, hasPreapprovalVisa }
}
